module.exports = __webpack_public_path__ + "static/media/pdf-icon.299dd72e.svg";